/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
*/
import React, { lazy, Suspense, useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../Body/Body.css";
import MediaQuery from "react-responsive";
import htmlParser from "html-react-parser";
const Form = lazy(() => import("../../components/SignUpForm/SignUpForm"));




export default function Body({angelAiLink, sunwestLink}) {
  const imgCDNURL = process.env.REACT_APP_MSTAR_CDN_URL;

  return (
    <>
      <div className="banner">
        <Container>
          <Row>
            <Col sm={12} md={12} xl={6} lg={6}>
              <div className="bannertextstag">
                <p className="mastertitle">
                  The Rise of Ai: Use It or Lose It
                </p>
                <ul className="word-list">
                  <li>No Tough Loans</li>
                  <li className="orange-bullet">
                    <span>Close Fast</span>
                  </li>
                  <li>Earn More</li>
                </ul>
                <div className="bannertextstag1">
                  <p className="texastop">
                    Dynamic Vibes, Joyful Gathering, and<br />Meaningful Bonds:
                  </p>
                  <p className="texastopmobile">
                    Dynamic Vibes,<br /> Joyful Gathering, and<br />Meaningful Bonds:
                  </p>
                </div>
                <div className="bannersteptext">
                  <h2 className="bannersteptext1">Texas Mortgage Roundup</h2>
                  <h2 className="bannersteptext2">- Dallas Leaves a Lasting<br />Impression</h2>

                  <h2 className="bannersteptext1mobile">Texas Mortgage Roundup <span className="bannersteptext2mobile">- Dallas Leaves a Lasting Impression</span></h2>
                </div>
              </div>
              <div>

              </div>
            </Col>
            <MediaQuery maxWidth={991}>
              <Col
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                className="conference-col"
              >
                <div className="getready-text">
                  <p>
                    The curtains came down on the Texas Mortgage Roundup - Dallas, bringing an end to a cherished chapter filled with memorable moments. The dynamic event proved to be a captivating hub of innovation, uniting esteemed mortgage practitioners and industry leaders to explore the latest trends and groundbreaking technologies shaping the field.
                  </p>
                  <p>
                    Truly delivering an unforgettable experience, the expo ignited inspiration and paved the way for a brighter future in the world of mortgages.
                  </p>
                  <p>
                    Stealing the limelight at the expo was none other than {htmlParser(angelAiLink)}, the extraordinary Ai loan assistant from {htmlParser(sunwestLink)} With her cutting-edge technology and unmatched expertise, {htmlParser(angelAiLink)} empowers mortgage professionals to accelerate deal closures like never before.
                  </p>
                </div>
              </Col>
            </MediaQuery>
            <MediaQuery minWidth={992}>
              <Col sm={12} md={12} xl={6} lg={6}>
                <div className="formsection">
                  <Suspense fallback={<div />}>
                    <Form />
                  </Suspense>
                </div>
              </Col>
            </MediaQuery>
          </Row>
        </Container>
      </div >
      <MediaQuery maxWidth={991}>
        <div className="mobileForm">
          <Col sm={12} md={12} xl={6} lg={6}>
            <div className="formsection">
              <Suspense fallback={<div />}>
                <Form />
              </Suspense>
            </div>
          </Col>
        </div>
      </MediaQuery>
    </>
  );
}
